




















































































































































































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import OnscreenMenu from "../../components/general/OnscreenMenu.vue";
import BirthdaysBirthdayDetails from "./BirthdaysBirthdayDetails.vue";

import BirthdayBookingJson from "../../shared/BirthdayBookingJson";
import CustomerJson from "../../shared/CustomerJson";

import UserJson from "../../shared/UserJson";

import { BirthdayBookingStatus } from "../../shared/BirthdayBookingStatus";
import { UserPermissionRank } from "../../shared/UserPermissionRank";
import { BirthdayBookingStaffAssignmentJson } from "../../shared/BirthdayBookingJson";
import TableView, { TableViewColumnDefinitions } from "../controls/TableView.vue";

export default Vue.extend({
  name: "BirthdaysAll",
  components: {
    Loading,
    OnscreenMenu,
    TableView,
    BirthdaysBirthdayDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    appFrameClickedButton: Object,
    BirthdayBookingStatusNames: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      showDetails: false,
      UserPermissionRank: UserPermissionRank,
      BirthdayBookingStatus: BirthdayBookingStatus,
      useFilters: false as boolean,
      filterState: null as BirthdayBookingStatus | null,
      allUsers: null as UserJson[] | null,
      requestedBirthdayBookings: null as BirthdayBookingJson[] | null,
      requestedBirthdayBookingsMoreAvailable: null as boolean | null,
      staffRequiredBirthdays: null as {
        birthdayBookings: BirthdayBookingJson[];
        moreAvailable: boolean | null;
      } | null,
      searchString: null as string | null,
      selectedBirthdayId: null as number | null,
      selectedBirthday: null as BirthdayBookingJson | null,
      detailsMode: "read",
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  methods: {
    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        this.loadData();
      }
    },

    loadData() {
      this.loadRequestedBirthdays();
      this.loadStaffRequiredBirthdays();
      this.loadAllUsers();
    },

    async reloadSelectedBirthday() {
      this.selectedBirthday = null;
      this.toggleDetails();
      if (this.selectedBirthdayId != null) {
        try {
          this.selectedBirthday = await this.restClient.getBirthdayBooking(this.selectedBirthdayId);
          this.openDetails(this.selectedBirthday, "read");
        } catch (e) {
          alert(e.message);
        }
      }
    },

    // START load birthdays

    async loadRequestedBirthdays(loadMore: null = null) {
      //show loading on search or remove search
      if (this.searchString !== null) {
        if (loadMore == null) {
          this.requestedBirthdayBookings = null;
        }
        if (this.searchString == "") {
          this.searchString = null;
        }
      }

      var states: BirthdayBookingStatus[] = [
        BirthdayBookingStatus.requestedStaffRequired,
        BirthdayBookingStatus.requestedNoStaffAvailable,
        BirthdayBookingStatus.requestedPendingConfirmation,
        BirthdayBookingStatus.offerToCustomer,
      ];

      var skipAmount = null as number | null;
      var afterDateTime = null;

      //filters
      if (this.useFilters) {
        if (this.filterState != null) {
          states = [this.filterState];
        }
      }

      //load more
      if (loadMore && this.requestedBirthdayBookings != null) {
        this.requestedBirthdayBookingsMoreAvailable = null;

        skipAmount = this.requestedBirthdayBookings.length;
      } else {
        this.requestedBirthdayBookings = null;
      }

      //final load
      if (this.restClient != null) {
        try {
          let birthdays = await this.restClient.getBirthdayBookings(
            states,
            null,
            afterDateTime,
            null,
            this.searchString,
            null,
            skipAmount
          );

          if (loadMore && this.requestedBirthdayBookings != null) {
            this.requestedBirthdayBookings = this.requestedBirthdayBookings.concat(birthdays.birthdayBookings);
          } else {
            this.requestedBirthdayBookings = birthdays.birthdayBookings;
          }

          this.requestedBirthdayBookingsMoreAvailable = birthdays.moreAvailable;
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadStaffRequiredBirthdays(loadMore: null = null) {
      var skipAmount = null as number | null;
      var states: BirthdayBookingStatus[] = [BirthdayBookingStatus.requestedStaffRequired];
      var afterDateTime = null;

      if (loadMore && this.staffRequiredBirthdays != null) {
        this.staffRequiredBirthdays.moreAvailable = null;

        skipAmount = this.staffRequiredBirthdays.birthdayBookings.length;
      } else {
        this.staffRequiredBirthdays = null;
      }

      if (this.restClient != null) {
        try {
          let birthdays = await this.restClient.getBirthdayBookings(
            states,
            null,
            afterDateTime,
            null,
            null,
            null,
            skipAmount
          );

          if (loadMore && this.staffRequiredBirthdays != null) {
            this.staffRequiredBirthdays.birthdayBookings = this.staffRequiredBirthdays.birthdayBookings.concat(
              birthdays.birthdayBookings
            );
            this.staffRequiredBirthdays.moreAvailable = birthdays.moreAvailable;
          } else {
            this.staffRequiredBirthdays = birthdays;
          }
        } catch (e) {
          alert(e.message);
        }
      }
    },

    // END load birthdays

    async loadAllUsers() {
      try {
        this.allUsers = await this.restClient.getUsers();
      } catch (e) {
        alert(e.message);
      }
    },

    resetSearchString() {
      this.searchString = "";
      this.loadRequestedBirthdays();
    },

    openDetails(item: BirthdayBookingJson | null, mode: string) {
      if (item != null) {
        //this.selectedBirthday = JSON.parse(JSON.stringify(item))
        this.selectedBirthdayId = item.ID;
      } else {
        this.selectedBirthdayId = null;
      }

      this.detailsMode = mode;
      this.toggleDetails();
    },

    applyUseFilters() {
      this.useFilters = true;
      (this.$refs.filterMenu as any).toggleOnscreenMenu();
      this.loadRequestedBirthdays();
    },

    removeUseFilters() {
      this.useFilters = false;
      (this.$refs.filterMenu as any).toggleOnscreenMenu();
      this.loadRequestedBirthdays();
    },

    async assignMeToBirthday(birthdayId: number) {
      try {
        let staffAssignment = {
          ID: birthdayId,
          staffId: this.loginId,
        };
        await this.restClient.assignBirthdayStaff(staffAssignment);
        this.loadData();
      } catch (e) {
        alert(e.message);
      }
    },

    getStaffFullName(staffId: number | null) {
      if (staffId != null) {
        if (this.allUsers != null) {
          let staff = this.allUsers.find((user) => user.ID == staffId);

          return staff?.firstName + " " + staff?.lastName;
        }
      } else {
        return "--";
      }
    },

    //tableView
    tableViewButtonClicked(button: string, item: any) {
      if (button == "openDetailsEdit") {
        this.openDetails(item, "edit");
      }
    },

    tableViewItemClicked(item: any) {
      this.openDetails(item, "read");
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.loadData();
      }
    },
  },
  computed: {
    permissionAbleManagement: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    birthdayColumns: function (): TableViewColumnDefinitions<BirthdayBookingJson>[] {
      let vue = this;

      return [
        {
          th: "Name (Erziehungsberechtigte:r)",
          td: (i) =>
            i.customer.guardianLastName != ""
              ? i.customer.guardianLastName + ", " + i.customer.guardianFirstName
              : "--",
        },
        {
          th: "Name (Kind)",
          td: (i) =>
            i.customer.childLastName != "" ? i.customer.childLastName + ", " + i.customer.childFirstName : "--",
        },
        {
          th: "Datum",
          td: (i) => DateFormatter.formatDateWeekday(new Date(i.beginDateTime)),
          sortBy: (i) => i.beginDateTime,
        },
        {
          th: "Uhrzeit",
          td: (i) =>
            DateFormatter.formatTime(new Date(i.beginDateTime)) +
            " – " +
            DateFormatter.formatTime(new Date(i.endDateTime)),
        },
        {
          th: "Programm",
          td: (i) => i.programTitle,
        },
        {
          th: "Ort",
          td: (i) => (i.location != "" ? i.location : "--"),
        },
        {
          th: "Status",
          td: (i) => vue.BirthdayBookingStatusNames[i.state],
        },
        {
          th: "Betreuer:in",
          td: (i) => vue.getStaffFullName(i.staffId),
        },
        {
          th: "",
          td: (i) => "Daten bearbeiten",
          style: (i) => "text-align:right",
          button: "openDetailsEdit",
        },
      ] as TableViewColumnDefinitions<BirthdayBookingJson>[];
    },

    /*
    staffRequiredBirthdays(): BirthdayBookingJson[] | null | undefined {
      if (this.requestedBirthdays != null) {
        var states = ["requestedStaffRequired"]
        var staffRequiredBirthdays = this.requestedBirthdays.filter(i =>
          states.includes(i.state)
        )
        return staffRequiredBirthdays
      }
    },
    */

    /*
    waitForCustomerReply(): BirthdayBookingJson[] | null | undefined {
      if (this.requestedBirthdays != null) {
        var states = ["offerToCustomer"]
        var waitForCustomerReply = this.requestedBirthdays.filter(i =>
          states.includes(i.state)
        )
        return waitForCustomerReply
      }
    }
    */
  },
});
